import { render, staticRenderFns } from "./PromocodeUpsertForm.vue?vue&type=template&id=2f4caa5a"
import script from "./PromocodeUpsertForm.vue?vue&type=script&lang=js"
export * from "./PromocodeUpsertForm.vue?vue&type=script&lang=js"
import style0 from "./PromocodeUpsertForm.vue?vue&type=style&index=0&id=2f4caa5a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports